/**
 * Created by tendlich
 *
 * this model specifies the filter and sorts for the table (gridview)
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var TicketModel = require("connection-models/ticketTab/TicketModel");
    var LE = require("app");


    var TicketsGridModel = {};

    LE.module("LEConnection",function () {
        TicketsGridModel = BaseModel.extend({
            defaults: {
                comparators: {
                    "status": TicketModel.KEYS.IS_CLOSED,
                    "contact": TicketModel.KEYS.CONTACT_NAME,
                    "priority": TicketModel.KEYS.PRIORITY,
                    "ticketnumber": TicketModel.KEYS.CASE_NUMBER,
                    "caseSubject": TicketModel.KEYS.SUMMARY,
                    "account": TicketModel.KEYS.ACCOUNT_NAME,
                    "creationDate": TicketModel.KEYS.CREATED_DATE,
                    "closedDate": TicketModel.KEYS.CLOSED_DATE,
                    "contactDetails": TicketModel.KEYS.CONTACT_NAME
                }
            }
        });
    });

    return TicketsGridModel;
});

